import { useEffect, useCallback } from "react";

const useKeyboardShortcuts = (shortcuts = []) => {
  const handler = useCallback(
    (e) => {
      const tag = document.activeElement?.tagName;
      const isEditable =
        tag === "INPUT" ||
        tag === "TEXTAREA" ||
        tag === "SELECT" ||
        document.activeElement?.isContentEditable;
      if (isEditable) return;

      for (const { key, ctrl, shift, alt, action } of shortcuts) {
        if (
          e.key === key &&
          (!ctrl || e.ctrlKey || e.metaKey) &&
          (!shift || e.shiftKey) &&
          (!alt || e.altKey) &&
          !(e.ctrlKey && !ctrl) &&
          !(e.shiftKey && !shift)
        ) {
          e.preventDefault();
          action(e);
          return;
        }
      }
    },
    [shortcuts]
  );

  useEffect(() => {
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [handler]);
};

export default useKeyboardShortcuts;
